 <template>
  <!-- <div class="">
    <PageHeader> </PageHeader> -->

  <div class="main layout-main">
    <div class="left">
      <div class="nav-left-title">
        <span class="icon-left">
          <img :src="$route.meta.icon" class="img" />
        </span>
        <span class="tit"> {{ $route.query.name }} </span>
      </div>
      <div class="nav-left-items" id="navLeft">
        <div
          style="
            width: 326px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          "
          v-for="(item, i) in categoryList"
          class="nav-left-item no-triangle"
          :class="{ active: i === getCurrentIndex }"
          :key="item.cate_id"
          :data-id="item.cate_id"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="right" v-loading="loading">
      <div class="nav-right-title" v-if="getCurrentIndex == '-1'">
        <div class="tit">{{ $route.query.name }}</div>
      </div>
      <div class="nav-right-title" v-if="categoryList[getCurrentIndex]">
        <div class="tit">{{ categoryList[getCurrentIndex].name }}</div>
      </div>
      <!-- <router-view></router-view> -->
      <List
        :categoryId="curCategoryId"
        :listMap="listMap"
        @currentChange="handleCurrentChange"
      ></List>
    </div>
  </div>
  <!-- <PageFooter> </PageFooter>
    <FixedLeft> </FixedLeft>
    <FixedRight> </FixedRight>
  </div> -->
</template>

<script>
import {
  getCategoryZhuanti_xin as getCategory,
  getCategoryZhuantiPage as getPage,
} from "@/apis/topic";
import List from "./components/List.vue";
import leftNavMixin from "@/views/dangjian/leftNavMixin";

export default {
  name: "TopicCategory",
  mixins: [leftNavMixin],
  components: {
    List,
  },
  data() {
    return {
      listMap: {},
      curCategoryId: 0,
      categoryList: [],
      loading: false,
    };
  },
  created() {
    this.getCategoryList();
  },
  methods: {
    async getCategoryList() {
      this.loading = true;
      const { data } = await getCategory({ pid: this.$route.query.id });
      const list = data.cate_list || [];
      this.categoryList = list;
      this.curCategoryId = 0;
      data.per_page = parseInt(data.article_list.per_page);
      this.$set(this.listMap, 0, Object.freeze(data.article_list));

      console.log(Object.freeze(data.article_list));
      this.initNavLeft();
      list.forEach((element) => {
        this.getPage(element.cate_id);
      });
      this.loading = false;
    },
    async getPage(cate_id, params = {}) {
      const { data } = await getPage({
        page: 1,
        pagenum: 10,
        cate_id: cate_id,
        ...params,
      });
      data.per_page = parseInt(data.per_page);
      console.log(Object.freeze(data));
      this.$set(this.listMap, cate_id, Object.freeze(data));
      // this.$set(this.listMap, cate_id, Object.freeze(list));
    },
    handleCurrentChange(page) {
      console.log(page);
      this.getPage(this.curCategoryId, { page });
    },
  },
  computed: {
    getCurrentIndex() {
      return this.categoryList.findIndex((v) => {
        return v.cate_id + "" === this.curCategoryId + "";
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/nav-layout.scss";
::v-deep .page-content {
  min-height: 900px;
}
.layout-main {
  padding: 0;
  margin: 0;
}
</style>
